import { render, staticRenderFns } from "./TabAcesso.vue?vue&type=template&id=c6b79054"
import script from "./TabAcesso.vue?vue&type=script&lang=ts"
export * from "./TabAcesso.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports